<script>
    export let fill
</script>

<style>
    svg {
        position: absolute;
        /* width: 413px; */
        /* height: 83.89px; */
    }
</style>

<svg id='teaminfo-navbar' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1170 402.46">
    <g id="Layer_2" data-name="Layer 2">
        <g id="topbar">
            <rect {fill} id="topbar-2" data-name="topbar" width="1170" height="402.46"/>
        </g>
    </g>
</svg>
